// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionSamples_wrapper__qCVYX","premiumFeatures":"SectionSamples_premiumFeatures__koh9g"};